// extracted by mini-css-extract-plugin
export default {"moveItemWrapper":"styles_moveItemWrapper__pa58f","moveItemTitle":"styles_moveItemTitle__LzTTe"};